const prod = {
  url: {
    API_URL: "https://gmg-ho-api.qatrace.com/api/",
    STORAGE_URL: "https://gmg-ho-api.qatrace.com/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
  },
};

const dev = {
  url: {
    // API_URL: "https://stg-gmg-ho-api.qatrace.com/api/",
    // STORAGE_URL: "https://stg-gmg-ho-api.qatrace.com/storage",
    // PRINTER_URL: "http://127.0.0.1:5003",
    API_URL: "http://127.0.0.1:8000/api/",
    STORAGE_URL: "https://gmg-ho-api.qatrace.com/storage",
    PRINTER_URL: "http://127.0.0.1:5003",
  },
};

const environmentConfig = process.env.NODE_ENV === "development" ? dev : prod;

export const config = {
  ...environmentConfig,
  url: {
    ...environmentConfig.url,
    API_URL: process.env.REACT_APP_API_URL || environmentConfig.url.API_URL,
    STORAGE_URL: process.env.REACT_APP_STORAGE_URL || environmentConfig.url.STORAGE_URL,
  },
};
